import {useState} from "react";
import {IoMailOpenOutline} from 'react-icons/io5'
import Button from "../Button/Button";
import {useDispatch} from "react-redux";
import {onAppAllowSound} from "../../store/Orders/actions";
import {useTranslation} from "react-i18next";

const AllowNotifications = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch();
    const [allowAudio, setAllowAudio] = useState(false)
    const onAllow = () => {
        const audioEl = document.getElementsByClassName("audio-element")[0]
        audioEl.muted = true;

        dispatch(onAppAllowSound());
        setAllowAudio(true)
    }

    if (allowAudio) return null;

    return (
        <div className="bg-indigo-600 max-w-screen-xl mx-auto py-2 sm:px-2 lg:px-6 rounded-md mt-5">
            <div className="flex items-center justify-between flex-wrap">
                <div className="w-0 flex-1 flex items-center min-w-0">
                    <IoMailOpenOutline color={'#ffffff'} size={30} />
                    <div className="ml-3" >
                        <div className="font-bold text-xl text-white truncate">
                            {t('Get alerts for new orders')}
                        </div>
                        <div className="font-medium text-sm text-white truncate">
                            {t('Enable notifications and you’ll never miss an order – even if you close this page.')}
                        </div>
                    </div>
                </div>

                <div className="flex-shrink-0 sm:ml-3">
                    <Button onClick={onAllow}>
                        {t('Allow Notifications')}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default AllowNotifications;
